module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "job-overview m-t-lg m-b-lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-request"
  }, [_vm._l((_vm.loads), function(load) {
    return _c('load-request-item', {
      key: load.id,
      attrs: {
        "load": load
      }
    })
  }), _vm._v(" "), (_vm.haveNoLoadRequests) ? _c('li', {
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("No load requests found.")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'loads.requests'
      }
    }
  }, [_vm._v("View All Load Requests")])], 1)]), _vm._v(" "), _c('load-request-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "far fa-question-circle"
  }), _vm._v(" Load Requests")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-718f4c8c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/LoadRequestList.vue
// module id = 1036
// module chunks = 0